import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import { Flex, Text } from "ui-components";
export { default as styles } from "./styles";

const Spinner = ({ sx, message }) => {
  return (
    <Flex data-testid="spinner" sx={{ ...sx, flexDirection: "column", alignItems: "center" }}>
      <ClipLoader sizeUnit="px" size={sx.size} color={sx.color} loading />
      {message && <Text mt={6} fontSize="20px" fontWeight="bold" textAlign="center">{message}</Text>}
    </Flex>
  );
};

Spinner.defaultProps = {
  sx: {}
};

export default Spinner;
